import React from "react";

const TitleMcSvg = () => (
  <svg
    width="302"
    height="34"
    viewBox="0 0 302 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.8"
      d="M24.8041 0.399998H34.1641V34H26.3881V11.152L22.0201 17.248L17.3161 23.68L12.6601 17.248L8.29206 11.152V34H0.564063V0.399998H9.87606L17.3161 10.768L24.8041 0.399998ZM72.5547 8.176H46.6827V13.312H72.5547V21.088H46.6827V26.272H72.5547V34H38.9547V0.399998H72.5547V8.176ZM77.3453 0.399998H110.897V34H103.169V8.176H98.0333V34H90.2573V8.176H85.0733V34H77.3453V0.399998ZM115.736 0.399998H149.336V34H141.56V21.088H123.464V34H115.736V0.399998ZM141.56 13.36V8.176H123.464V13.36H141.56ZM161.231 0.399998H186.239V34H178.511V8.176H167.759L163.727 34H152.687V26.272H157.199L161.231 0.399998ZM224.664 0.399998V21.088H215.304L224.616 34H215.304L205.992 21.088H198.792V34H191.064V0.399998H198.792V13.312H216.888V0.399998H224.664ZM229.455 0.399998H263.055V34H229.455V0.399998ZM237.183 26.272H255.279V8.176H237.183V26.272ZM267.845 0.399998H301.397V21.088H275.573V34H267.845V0.399998ZM293.669 13.312V8.176H275.573V13.312H293.669Z"
      fill="white"
    />
  </svg>
);

export default TitleMcSvg;
